const ENDPOINTS = {
  RECORDED_CONTACTS: "/contact-management/recorded-contact",
  THIRD_PARTY_CONTACTS: "/contact-management/third-party-contact",
  USERS: {
    USERS: "/user-management/users",
    MARK_TRAINING_SEEN: "/user-management/users/mark-training-video-seen",
    FETCH_TRAINING_VIDEOS: "/user-management/users/training/list",
    MARK_TRAINING_VIDEO_COMPLETED: "/user-management/users/training/complete",
  },
  RECORDED_CALLS: {
    GET_RECORDED_CALLS: "/recordings/recorded-call",
    GET_RECORDING_PLAYBACK: "/recordings/recorded-call",
    GET_RECORDING_DOWNLOAD: "/recordings/recorded-call",
    RETAIN_RECORDED_CALL: "/recordings/recorded-call",
    RELEASE_RECORDED_CALL: "/recordings/recorded-call",
  },
  AUTH: {
    LOGIN: "/user-management/auth/login",
    LOGOUT: "/user-management/auth/logout",
    VERIFY: "/user-management/auth/verify-user",
    FORGOT_PASSWORD: "/user-management/auth/forgot-password",
    RESET_PASSWORD: "/user-management/auth/reset-password",
    REFRESH_TOKEN: "/user-management/auth/refresh-token",
  },
  PLAYLIST: {
    GET_PLAYLISTS: "/recordings/playlist",
    CREATE_PLAYLIST: "/recordings/playlist",
    GET_PLAYLIST_CALLS: "/recordings/playlist",
    MARK_AS_REVIEWED: "/recordings/playlist",
    GET_PLAYLIST_CALL_AUDIO: "/recordings/playlist",
  },
  RECORDED_CONTACTS_INSIGHTS: "/insights/recorded-contacts",
  REPORTS: "/insights/reports",
};

export default ENDPOINTS;
